<template>
    <b-modal id="modal-transactions" centered class="modal-transactions" ref="modalTransaction" @shown="onModalShown">
      <div class="modal-transactions-itens">
        <button
          class="modal-transactions-itens-close"
          @click="$bvModal.hide('modal-transactions')"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55">
            <g id="Group_6317" data-name="Group 6317" transform="translate(-1270 -213)">
                <circle id="Ellipse_1" data-name="Ellipse 1" cx="27.5" cy="27.5" r="27.5" transform="translate(1270 213)" fill="#e84e0f"/>
                <text id="X" transform="translate(1297 251)" fill="#fff" font-size="30" font-family="Poppins-Regular, Poppins"><tspan x="-9.315" y="0">X</tspan></text>
            </g>
        </svg>
        </button>
      </div>
      <div class="modal-transactions-content">
        <div class="modal-transactions-content-header">
            <img v-if="transactions[0]?.img_loja" :src="'https://imgs.app.freebee.pt/redes/' + transactions[0].img_loja" alt="">
            <img v-else src="@/assets/img/not-found.png" alt="">
            <div>
                <h3>{{ transactions[0].loja }}</h3>
                <h4>{{ $t('balance') }} {{ transactions[0].saldo_actual }}</h4>
            </div>
        </div>
        <div class="modal-transactions-content-transactions">
            <h3 class="v-content-transaction-detail" v-contentTransactionDetail="{ section: 'Detalhe Transações', removeHtml: true }">Últimas 5 transações</h3>
            <div v-for="t in transactions.slice(0, 5)" :key="t.id" class="modal-transactions-content-transactions-items">
                <div class="modal-transactions-content-transactions-items-transaction">
                    <p>{{ t.data }} </p>
                    <h4>{{ t.total_discount }}</h4>
                </div>
            </div>
        </div>
      </div>
    </b-modal>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import axios from 'axios';
  import store from '@/store';
  
  const allContents = [];
  const lang = localStorage.getItem('locale') || 'es';
  
  export default {
    props: {
      transactions: {
        type: Array, // Altere para Array se transactions for um array de objetos
        default: () => []
      }
    },
    computed: {
      ...mapState('App', ['loading']),
    },
    methods: {
      onModalShown() {
        if (this.$refs.modalTransaction && this.$refs.modalTransaction.$el) {
            this.$nextTick(() => {
            this.updateDirectives();
            });
        }
      },
      updateDirectives() {
        const allElements = document.querySelectorAll('.v-content-transaction-detail');
        allContents.splice(0, allContents.length); // Clear the contents array
        allElements.forEach((el) => {
          const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
          params.content = el.innerHTML.trim();
          if (!('type' in params)) params.type = 'text';
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
        });

        if (allElements.length == allContents.length) {
          store.dispatch('App/loading', true);
          axios({
            method: "POST",
            url: '/api/v1/site/get-all-contents',
            data: { allContents, lang }
          })
          .then(response => response.data)
          .then((data) => {
            const allElements = document.querySelectorAll('.v-content-transaction-detail');
            allContents.forEach((el) => {
              if (el.type == 'text') {
                allElements.forEach((el, index) => {
                  el.innerHTML = data.data[index];
                });
              }
            });
            store.dispatch('App/loading', false);
          });
        }
      },
    },
    created() {
      this.updateDirectives();
    },
    directives: {
      contentTransactionDetail: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-transaction-detail');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          if (!('type' in params)) params.type = 'text';
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          el.dataset.params = JSON.stringify(params);
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
            .then(response => response.data)
            .then((data) => {
              const allElements = document.querySelectorAll('.v-content-transaction-detail');
              allContents.forEach((el) => {
                if (el.type == 'text') {
                  allElements.forEach((el, index) => {
                    el.innerHTML = data.data[index];
                  });
                }
              });
              store.dispatch('App/loading', false);
            });
          }
        },
      }
    }
  };
  </script>
  
<style lang="scss">
.modal-footer{
    display: none;
}
.modal-header{
    display: none;
}
#modal-transactions .modal-content{
    background-color: #fff;
    border-radius: 10px;
    width: 100%;
    max-width: 570px;
    height: 606px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    .modal-body{
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        .modal-transactions-itens{
            button{
                all: unset;
                position: absolute;
                top: -30px;
                right: -30px;
            }
        }
        .modal-transactions-content{
            height: 100%;
            width: 100%;
            margin: 30px 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            gap: 40px;
            &-header{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 20px;
                width: 100%;
                img{
                    width: 100%;
                    max-width: 103px;
                    border-radius: 10pxs;
                    height: auto;
                    object-fit: contain;
                }
                h3{
                    margin-bottom: 20px;
                    font-size: 26px;
                    line-height: 36px;
                    letter-spacing: 2px;
                    color: #000;
                    font-family: 'Font Bold';
                    text-transform: capitalize;
                }
            }
            &-transactions{
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 10px;
                width: 100%;
                &-items{
                    width: 100%;
                    height: 60px;
                    border-bottom: 1px solid #CBCFD2;
                    &-transaction{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        flex-direction: row;
                        p{
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 2px;
                            color: #000;
                            font-family: 'Font Regular';
                            text-transform: capitalize;
                        }
                        h4{
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 2px;
                            color: #000;
                            font-family: 'Font Bold';
                            text-transform: capitalize;
                        }
                    }
                }
            }
        }
    }
}

</style>
  